/**
 * PlaceholderPage — "Coming Soon" page for unbuilt sections.
 * Shown when a sidebar nav item is clicked that doesn't have a real page yet.
 */

import React from 'react';
import { Link } from 'react-router-dom';

const DESCRIPTIONS = {
  '/market':      'Track share price movements, top movers, and trending runners across all active showdowns.',
  '/community':   'Connect with rivals, create private leagues, challenge friends, and follow the Syndicator Feed.',
  '/learn':       'How to play guides, strategy tips, tournament rules, and video walkthroughs.',
  '/account':     'Manage your profile, notification preferences, PIN login, and responsible gaming settings.',
};

export const PlaceholderPage = ({ path, label, icon }) => {
  const description = DESCRIPTIONS[path] || 'This feature is currently in development.';

  return (
    <div style={{
      display:        'flex',
      flexDirection:  'column',
      alignItems:     'center',
      justifyContent: 'center',
      minHeight:      '60vh',
      padding:        '40px 24px',
      textAlign:      'center',
    }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>{icon || '🚧'}</div>
      <h1 style={{
        fontSize:   28,
        fontWeight: 700,
        color:      'var(--text-primary)',
        margin:     '0 0 12px',
      }}>
        {label} — Coming Soon
      </h1>
      <p style={{
        fontSize:   15,
        color:      'var(--text-secondary)',
        maxWidth:   480,
        lineHeight: 1.6,
        margin:     '0 0 32px',
      }}>
        {description}
      </p>
      <Link
        to="/dashboard"
        style={{
          display:        'inline-flex',
          alignItems:     'center',
          gap:            8,
          padding:        '10px 24px',
          background:     'var(--accent-blue)',
          color:          '#fff',
          borderRadius:   8,
          textDecoration: 'none',
          fontSize:       14,
          fontWeight:     700,
        }}
      >
        ← Back to Dashboard
      </Link>
    </div>
  );
};

export default PlaceholderPage;
